import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import colors from 'UIKit/Colors';

import TextareaResizeIcon from '@/assets/img/TextareaResizeIcon.png';

export const TextareaStyled = styled.textarea`
  display: block;
  position: relative;
  width: 100%;
  min-height: 112px;
  border-radius: 19px;
  padding: 0.625rem;
  border: 1px solid #ddd;
  color: #464d69;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  resize: vertical;
  &::-webkit-resizer {
    display: none;
  }
  &:focus {
    outline: 0;
  }
  ~ .label {
    position: relative;
    padding-left: 28px;
    cursor: pointer;
    font-size: 14px;
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      width: 18px;
      height: 18px;
      border-radius: 2px;
      border: 1px solid ${colors.brand['500']};;
      //background-color: ${colors.brand['500']};
    }
    &:after {
      content: '';
      opacity: 0;
      position: absolute;
      top: 3px;
      left: 4px;
      display: block;
      width: 10px;
      height: 6px;
      border-left: 2px solid ${colors.white['0']};
      border-bottom: 2px solid ${colors.white['0']};
      transform: rotate(-45deg);
      transition: opacity 0.15s ease-in-out;
    }
  }
`;

export const Wrap = styled.div`
  background: linear-gradient(
    180deg,
    rgba(41, 10, 89, 0.65) 0%,
    rgba(255, 124, 0, 0.65) 100%
  );
  padding: 1px;
  border-radius: 20px;
  &:after {
    content: '';
    display: block;
    background-image: url(${TextareaResizeIcon});
    width: 15px;
    height: 15px;
    position: absolute;
    right: 6px;
    bottom: 6px;
  }
`;

export const StyledLabel = styled.label``;
export const Label = styled.div`
  font-size: 13px;
  color: #a3a3a3;
  &:not(:last-child) {
    margin-bottom: 4px;
  }
`;

export const Error = styled.div`
  font-size: 0.875rem;
  color: ${({ warning }) => (warning ? 'orange' : '#f55145')};
  &:not(:first-child) {
    margin-top: 4px;
  }
`;

const RenderCustomTextarea = ({
  input,
  label,
  type,
  meta: { touched, error, warning },
  placeholder,
  disabled,
  autocomplete,
}) => (
  <StyledLabel>
    {type !== 'checkbox' && label && <Label>{label}</Label>}
    <Wrap>
      <TextareaStyled
        {...input}
        autoComplete={autocomplete}
        placeholder={placeholder}
        type={type}
        disabled={disabled}
      />
    </Wrap>
    {type === 'checkbox' && <Label className="label">{label}</Label>}
    {touched &&
      ((error && (
        <Error>
          <FormattedMessage id={error} defaultMessage="" />
        </Error>
      )) ||
        (warning && <Error warning>{warning}</Error>))}
  </StyledLabel>
);

RenderCustomTextarea.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  autocomplete: PropTypes.string,
};

RenderCustomTextarea.defaultProps = {
  disabled: false,
  placeholder: '',
  label: '',
  type: 'text',
  autocomplete: null,
};

export default RenderCustomTextarea;
